import React from 'react';
import ayurvedic from '../img/ayurvedic.jpg';
import stethoscope from '../img/stethoscope.jpg';
import nebulizer from '../img/nebulizer.jpg';

const Facilities = () => {
	return (
		<facilities className="center">
			<section className="facilities" id="facilities">
				<div className="max-width">
					<h2 className="title">Facilities</h2>
					<div className="carousel">
						<div className="facility-content">
							<div className="card">
								<div className="box">
									<img src={stethoscope} alt="" />
									<div className="text">Integrated Treatment</div>
									<p />
								</div>
							</div>
							<div className="card">
								<div className="box">
									<img src={ayurvedic} alt="" />
									<div className="text">Ayurvedic Treatment</div>
									<p />
								</div>
							</div>
							<div className="card">
								<div className="box">
									<img src={nebulizer} alt="" />
									<div className="text">Nebulization Facility </div>
									<p />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</facilities>
	);
};

export default Facilities;
